import styled from 'styled-components';
import is from 'styled-is';

import StageActions from './container';
import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

const StyledActionButton = styled.button`
  width: 100%;
  height: 100%;
  background: transparent;
  -webkit-appearance: none;
  border: 0;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--primary900);
  background: var(--primary100);
  &:hover {
    background: var(--primary200);
  }

  ${is('disabled')`
    opacity: .4;
    &:hover{
      background: var(--primary100);
    }
  `}
`;

export default styled(StageActions)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border: 0;
  z-index: ${Z_INDEX.ACTIONS};
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  pointer-events: none;

  > * {
    flex: 1 1 100%;
    height: 100%;
    display: block;
    padding-left: 0;
    padding-right: 0;
  }

  ${is('over')`
    transform: translateY(50%);
  `}

  ${is('opened')`
    transform: translateY(0%);
    pointer-events: all;
  `}
`;

export { StyledActionButton };
